import { BlogSection } from '@/types/blog';

export const ctaSection: BlogSection = {
  id: 'ihre-erfahrungen',
  title: 'Ihre Erfahrungen mit KI-gestützter Entwicklung?',
  content: `
    <p>
      Haben Sie bereits Erfahrungen mit KI-Tools in der Webentwicklung oder anderen Bereichen gemacht? 
      Als Finanzcoach und Technologie-Enthusiast interessiere ich mich sehr für Ihre Perspektive auf 
      diese neue Art der Zusammenarbeit zwischen Mensch und Maschine.
    </p>
    
    <p>
      Falls Sie Interesse an einem Erfahrungsaustausch haben oder sich fragen, wie Sie innovative Technologien 
      in Ihrem Bereich einsetzen können, freue ich mich über Ihre Nachricht. Manchmal sind es gerade die 
      neuen Werkzeuge, die uns dabei helfen, unsere Ziele effizienter zu erreichen.
    </p>
  `
};
